import React, { useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { useVerifyEmail } from './User.hooks';
import { VerifyEmail } from './User.interface';

import * as Styled from '../login/Login.styled';
import logo from '../assets/logo';

const UserEmailVerification = () => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');
  const { emailVerified, isLoading, error, get } = useVerifyEmail();
  const success = !isLoading && !error && !!emailVerified;

  useEffect(() => {
    if (token) {
      const verifyEmail: VerifyEmail = { token };
      get(verifyEmail);
    }
  }, [get, token]);

  if (emailVerified && !emailVerified.user?.isPasswordSet) {
    return (
      <Redirect to={'/password/reset?token=' + emailVerified.accessToken} />
    );
  }

  return (
    <Styled.StyledLoginContainer>
      <Styled.StyledLoginCard>
        <img src={logo} alt='Sierra Labs' className='logo' />
        <h2>Email Verification</h2>
        <Styled.StyledLoginCardContent>
          {isLoading && <p>Verifying Email...</p>}
          {error && (
            <Alert severity='error'>
              Email verification link expired. Please contact your administrator
              for a new invitation.
            </Alert>
          )}
          {success && (
            <>
              <div>Your account has been verified!</div>
              <div>You may now proceed to the login page to sign in.</div>
            </>
          )}
        </Styled.StyledLoginCardContent>

        {success && (
          <Link className='forgot-password-link' to='/login'>
            Proceed to Login
          </Link>
        )}
      </Styled.StyledLoginCard>
    </Styled.StyledLoginContainer>
  );
};

export default UserEmailVerification;
